import { ENVIRONMENT_QUAL } from './qual';

export const environment = {
  ...ENVIRONMENT_QUAL,
  apiServer: 'https://mercury.app.1life.com',
  auth0: {
    audience: 'https://onemedical.com',
    clientId: 'zNDgW1mC9Dc5wr4JXWvQUrGQuQqvkyKW',
    domain: 'mercuryqual-onemedical.us.auth0.com',
  },
  myoneServer: 'https://mercury.app.1life.com',
  sentry: {
    enabled: true,
    dsn: 'https://94fb2cb964527591835f763ad4493a4f@o4506221115408384.ingest.us.sentry.io/4506855554154496',
    environment: 'onelife-mercury',
  },
  launchDarklyClientId: '605034fc9a881a0c380e4b0f',
  stripePublishableKey: 'pk_test_LYcNRmAVxdwSnjPXrKcnpApT',
};
